import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL_NEW } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params.ts';

export type SubscriptionItem = {
  id: number;
  sku: string;
  start_date: string | null;
  end_date: string | null;
  cancel_date: string | null;
  auto_renew: boolean;
  suspended: boolean;
  billing_channel: string; // "scriptix" | "azure" | future strings
};

export type SubscriptionsResponse = {
  count: number;
  total_results: number;
  result: SubscriptionItem[];
};

export const useGetAllSubscriptions = () => {
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;
  const sort = (searchParams.sort as string | undefined) || undefined;
  const direction =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;
  const q = (searchParams.q as string | undefined) || undefined;

  const fetchSubscriptions = async () => {
    const { allSubscriptions } = GET_URL_NEW();
    const url = allSubscriptions({ offset, limit, sort, direction, q });
    const { data } = await Axios.get<SubscriptionsResponse>(url);
    return data;
  };

  return useQuery<SubscriptionsResponse, AxiosError<BaseError>>(
    ['subscriptions', offset, limit, q, sort, direction],
    fetchSubscriptions,
    { keepPreviousData: true }
  );
};
